import { useCallback, useEffect } from 'react';
import { DefaultValues, FieldValues, useForm, UseFormProps } from 'react-hook-form';
import { isEqual, pick } from 'lodash-es';

interface Props<TFieldValues extends FieldValues = FieldValues, TContext extends object = object>
  extends UseFormProps<TFieldValues, TContext> {
  defaultValues: DefaultValues<TFieldValues>;
  onUpdate?: (value: TFieldValues) => void;
}
export const useFilterForm = <
  TFieldValues extends FieldValues = FieldValues,
  TContext extends object = object,
>(
  props: Props<TFieldValues, TContext>,
) => {
  const result = useForm(props);

  const { defaultValues, onUpdate } = props;

  const { reset, getValues, trigger } = result;

  useEffect(() => {
    reset(defaultValues);
  }, [defaultValues, reset]);

  const onChangeItem = useCallback(async () => {
    if (!onUpdate) return;
    const values = getValues();

    const oldValues = pick(defaultValues, Object.keys(values));

    if (isEqual(oldValues, values)) return;

    const isValid = await trigger();

    if (!isValid) return;

    onUpdate(values);
  }, [getValues, defaultValues, onUpdate, trigger]);

  return { ...result, onChangeItem };
};
